import { TEMPLATE_DEPLOYMENT_OUTPUTS_COLUMN_ID } from "../constants";
import TemplateDeploymentOutputsDescriptionCell from "./DescriptionCell";
import TemplateDeploymentOutputsDropdownActionsCell from "./DropdownActionsCell";
import TemplateDeploymentOutputsNameCell from "./NameCell";
import TemplateDeploymentOutputsStackCell from "./StackCell";
import TemplateDeploymentOutputsValueCell from "./ValueCell";

export const TEMPLATE_DEPLOYMENT_OUTPUTS_TABLE_CELLS = {
  [TEMPLATE_DEPLOYMENT_OUTPUTS_COLUMN_ID.NAME]: TemplateDeploymentOutputsNameCell,
  [TEMPLATE_DEPLOYMENT_OUTPUTS_COLUMN_ID.DESCRIPTION]: TemplateDeploymentOutputsDescriptionCell,
  [TEMPLATE_DEPLOYMENT_OUTPUTS_COLUMN_ID.VALUE]: TemplateDeploymentOutputsValueCell,
  [TEMPLATE_DEPLOYMENT_OUTPUTS_COLUMN_ID.STACK]: TemplateDeploymentOutputsStackCell,
  [TEMPLATE_DEPLOYMENT_OUTPUTS_COLUMN_ID.DROPDOWN]: TemplateDeploymentOutputsDropdownActionsCell,
};
